"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./allFaces"), exports);
tslib_1.__exportStar(require("./ComposableTask"), exports);
tslib_1.__exportStar(require("./ComputeFaceDescriptorsTasks"), exports);
tslib_1.__exportStar(require("./detectFaces"), exports);
tslib_1.__exportStar(require("./DetectFacesTasks"), exports);
tslib_1.__exportStar(require("./DetectFaceLandmarksTasks"), exports);
tslib_1.__exportStar(require("./FaceMatcher"), exports);
tslib_1.__exportStar(require("./nets"), exports);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/globalApi/index.js
 ** module id = 1477
 ** module chunks = 0
 **/